import { redirect } from 'redux-first-router'
import { callApi, getDefaultEditActions, addExtraFilterToQuery } from './helpers'

export const loadDzeramaUdensSatecesBaseini = (query) => (dispatch, getState) => {
    const mapSize = getState().gui['dzerama_udens_sateces_baseini_saraksts_karte_size']
    return dispatch(callApi({
        viewName: 'dzerama_udens_sateces_baseins_list',
        crudMethod: 'listPaging',
        crudParam: addExtraFilterToQuery(query, mapSize)
    }))
}

export const dzeramaUdensSatecesBaseinsSelected = (id) => {
    return { type: 'dzeramaUdensSatecesBaseini_selected', payload: id }
}

export const dzeramaUdensSatecesBaseinsInMapSelected = (payload) => {
    return { type: 'dzeramaUdensSatecesBaseini_selected', payload }
}

export const dzeramaUdensSatecesBaseinsActions = getDefaultEditActions({
    actionTypeName: 'dzeramaUdensSatecesBaseins',
    stateName: 'dzeramaUdensSatecesBaseins',
    apiViewName: 'dzerama_udens_sateces_baseins_view',
    afterDelete: (dispatch) => {
        dispatch(redirect({ type: 'loc_dzerama_udens_sateces_baseini' }))
    },
    valuesTransformator: (values, getState) => {
        const reduxUiv = getState().dzeramaUdensSatecesBaseins.selectedItem?.udens_ieguves_vietas
        if (reduxUiv && values.udens_ieguves_vietas) {
            const reduxByUrbumiId = {}
            reduxUiv.forEach(u => { if (u.urbumi_id) reduxByUrbumiId[u.urbumi_id] = u })
            values = {
                ...values,
                udens_ieguves_vietas: values.udens_ieguves_vietas.map(uiv => {
                    const ru = reduxByUrbumiId[uiv.urbumi_id]
                    if (ru) {
                        return {
                            ...uiv,
                            stingra_aizsargjosla: ru.stingra_aizsargjosla,
                            bakter_aizsargjosla: ru.bakter_aizsargjosla,
                            kim_aizsargjosla: ru.kim_aizsargjosla,
                            pasakumi: ru.pasakumi,
                            piezimes: ru.piezimes
                        }
                    }
                    return uiv
                })
            }
        }
        return values
    },
    afterSave: (dispatch, getState, result, savingNew) => {
        dispatch({
            type: 'dzerama_udens_sateces_baseins_clear'
        })
        const query = getState().location.query || {}
        dispatch(redirect({
            type: 'loc_dzerama_udens_sateces_baseins',
            payload: {
                id: result.id
            },
            query
        }))
    },
})

export const updateUrbumsAizsargjosla = (urbumi_id, field, value) => ({
    type: 'dzeramaUdensSatecesBaseins_update_aizsargjosla',
    payload: { urbumi_id, field, value }
})

export const dzeramaUdensSatecesBaseinsVisparigaInfoActions = getDefaultEditActions({
    actionTypeName: 'dzeramaUdensSatecesBaseinsVisparigaInfo',
    stateName: 'dzeramaUdensSatecesBaseinsVisparigaInfo',
    apiViewName: 'dzerama_udens_sateces_baseins_vispariga_info_view',
})

export const loadZemesLietojums = (id) => dispatch => {
    return dispatch(callApi({
        viewName: 'dzerama_udens_sateces_baseins_zemes_lietojums_view',
        crudMethod: 'get',
        crudParam: id
    }))
}

export const loadSituacijaList = (query) => dispatch => {
    dispatch(callApi({
        viewName: 'dzur_aktuala_situacija_view',
        crudMethod: 'list',
        crudParam: { f: JSON.stringify({ 'dzusb_id': parseInt(query.id) }) }
    }))
}

export const searchUrbumiAtradnesGeom = (ua_id) => (dispatch, getState) => {
    return dispatch(callApi({
        viewName: 'urbumi_atradnes_geom_search',
        crudMethod: 'list',
        crudParam: { f: JSON.stringify({ 'ua_id': ua_id }) }
    }))
}

export const dzurAktualaSituacijaSelected = (id) => ({
    type: 'dzur_aktuala_situacija_selected',
    payload: id
})

// riska objektu kategorijas

export const loadRiskaKategorijas = (query) => (dispatch) => {
    return dispatch(callApi({
        viewName: 'riska_objektu_kategorijas_edit',
        crudMethod: 'listPaging',
        crudParam: query
    }))
}

export const loadRiskaKategorijasIfNeeded = (forced = false) => (dispatch, getState) => {
    if (forced || getState().riskaObjektuKategorijas.lastReqId === 0) {
        return dispatch(callApi({
            viewName: 'riska_objektu_kategorijas_edit',
            crudMethod: 'list'
        }))
    }
}

export const riskaObjektuKategorijaSelected = (id) => {
    return { type: 'riskaObjektuKategorija_selected', payload: id }
}

const riskaObjektuKategorijasAfterSaveOrDelete = (dispatch, getState) => {
    dispatch(loadRiskaKategorijas(getState().location.query))
}

export const riskaObjektuKategorijasActions = getDefaultEditActions({
    actionTypeName: 'riskaObjektuKategorija',
    stateName: 'riskaObjektuKategorijas',
    combinedPage: true,
    apiViewName: 'riska_objektu_kategorijas_edit',
    afterDelete: riskaObjektuKategorijasAfterSaveOrDelete,
    afterSave: riskaObjektuKategorijasAfterSaveOrDelete,
})

// riska novertejumi

export const loadRiskaNovertejumiList = (dzusb_id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejumi_list',
        crudMethod: 'list',
        crudParam: { f: JSON.stringify({ 'dzusb_id': parseInt(dzusb_id) }) },
        success: (result) => result
    }))
}

export const loadRiskaNovertejums = (id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejumi_view',
        crudMethod: 'get',
        crudParam: ['id', parseInt(id)],
        success: (result) => result
    }))
}

export const riskaNovertejumsSelected = (id) => {
    return { type: 'riska_novertejums_selected', payload: id }
}

export const riskaNovertejumuObjektSelected = (id) => {
    return { type: 'riska_novertejumu_objekts_selected', payload: id }
}

export const createJaunsRiskaNovertejums = (dzusb_id) => async (dispatch) => {
    try {
        let riskaNovertejumsId = null
        await dispatch(callApi({
            viewName: 'riska_novertejumi_view',
            crudMethod: 'save',
            crudParam: {
                dzerama_udens_sateces_baseins_id: parseInt(dzusb_id),
            },
            success: (result) => {
                riskaNovertejumsId = result.id
                return result
            }
        }))

        if (!riskaNovertejumsId) {
            throw new Error('Neizdevas izveidot riska novērtējumu')
        }

        return { id: riskaNovertejumsId }
    } catch (error) {
        throw error
    }
}

export const advanceRiskaNovertejumaStatuss = (id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejumi_statuss_update',
        crudMethod: 'save',
        crudParam: { id: parseInt(id) }
    }))
}

export const toggleDzeramaUdensSatecesBaseinsArhivets = (id, irArhivets) => async (dispatch) => {
    await dispatch(callApi({
        viewName: 'dzerama_udens_sateces_baseins_arhivet_view',
        crudMethod: 'save',
        crudParam: {
            id: parseInt(id),
            ir_arhivets: irArhivets
        }
    }))
    return dispatch(dzeramaUdensSatecesBaseinsActions.fetchAct({ id: parseInt(id) }))
}

export const loadRiskaNovertejumuObjekti = (riska_novertejumi_id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejuma_objekti_view',
        crudMethod: 'list',
        crudParam: { f: JSON.stringify({ 'riska_novertejumi_id': parseInt(riska_novertejumi_id) }) },
        success: (result) => result
    }))
}

export const updateRiskaObjektaVarbutiba = (id, varbutiba_eksperta, eksperta_komentars) => dispatch => {
    const payload = {
        id: parseInt(id),
        varbutiba_eksperta: parseInt(varbutiba_eksperta),
        eksperta_komentars: eksperta_komentars
    };
    return dispatch(callApi({
        viewName: 'riska_objekta_eksperta_novertejums_update',
        crudMethod: 'save',
        crudParam: payload
    }))
}

export const updateRiskaKategorijasVarbutiba = (id, varbutiba_eksperta, eksperta_komentars) => dispatch => {
    const payload = {
        id: parseInt(id),
        varbutiba_eksperta: parseInt(varbutiba_eksperta),
        eksperta_komentars: eksperta_komentars
    };
    return dispatch(callApi({
        viewName: 'riska_kategorijas_eksperta_novertejums_update',
        crudMethod: 'save',
        crudParam: payload
    }))
}

export const loadRiskaNovertejumaParametri = (riska_novertejumi_id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejuma_parametri_view',
        crudMethod: 'list',
        crudParam: { f: JSON.stringify({ 'riska_novertejumi_id': parseInt(riska_novertejumi_id) }) },
        success: (result) => result
    }))
}

export const loadRiskaNovertejumuDokumenti = (riska_novertejumi_id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejumu_dokumenti_view',
        crudMethod: 'list',
        crudParam: { f: JSON.stringify({ 'riska_novertejumi_id': parseInt(riska_novertejumi_id) }) },
        success: (result) => result
    }))
}

const riskaNovertejumuAfterSaveOrDelete = (dispatch, getState) => {
    const dzusb_id = getState().location.payload?.id
    if (dzusb_id) {
        dispatch(loadRiskaNovertejumiList(dzusb_id))
    }
}

export const riskaNovertejumuActions = getDefaultEditActions({
    actionTypeName: 'riskaNovertejums',
    stateName: 'riskaNovertejumi',
    apiViewName: 'riska_novertejumi_view',
    afterDelete: riskaNovertejumuAfterSaveOrDelete,
    afterSave: riskaNovertejumuAfterSaveOrDelete,
})

export const riskaNovertejumuPamatinfoActions = getDefaultEditActions({
    actionTypeName: 'riskaNovertejumsPamatinfo',
    stateName: 'riskaNovertejumiPamatinfo',
    apiViewName: 'riska_novertejumi_pamatinfo_view',
    afterSave: riskaNovertejumuAfterSaveOrDelete,
    overridedActions: {
        stopEditAct: () => (dispatch) => {
            dispatch({ type: 'riskaNovertejumsPamatinfo_stop_edit' })
        }
    }
})

export const loadRiskaNovertejumsPamatinfo = (id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejumi_pamatinfo_view',
        crudMethod: 'get',
        crudParam: ['id', parseInt(id)]
    }))
}

export const riskaObjektiRowSelected = (payload) => ({
    type: 'dzur_riska_objekti_row_selected',
    payload
})

// Pasākumi

export const loadRiskaNovertejumuPasakumi = (riska_novertejumi_id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejumu_pasakumi_view',
        crudMethod: 'list',
        crudParam: { f: JSON.stringify({ 'riska_novertejumi_id': parseInt(riska_novertejumi_id) }) },
        success: (result) => result
    }))
}

export const loadRiskaPreventiviePasakumi = () => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_preventivie_pasakumi_view',
        crudMethod: 'list',
        crudParam: {},
        success: (result) => result
    }))
}

export const loadRiskaNovertejumaPreventiviePasakumiSnapshot = (riska_novertejumi_id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejuma_preventivie_pasakumi_view',
        crudMethod: 'list',
        crudParam: { f: JSON.stringify({ 'riska_novertejumi_id': parseInt(riska_novertejumi_id) }) },
        success: (result) => result
    }))
}

export const saveRiskaNovertejumaPasakums = (riska_novertejumi_id, apraksts, id = null) => dispatch => {
    const payload = {
        riska_novertejumi_id: parseInt(riska_novertejumi_id),
        apraksts: apraksts
    }
    if (id) {
        payload.id = parseInt(id)
    }
    return dispatch(callApi({
        viewName: 'riska_novertejumu_pasakumi_view',
        crudMethod: 'save',
        crudParam: payload
    }))
}

export const deleteRiskaNovertejumaPasakums = (id) => dispatch => {
    return dispatch(callApi({
        viewName: 'riska_novertejumu_pasakumi_view',
        crudMethod: 'delete',
        crudParam: parseInt(id)
    }))
}